import React from 'react';

const CommentInput = props => {
    return (
      <input
        onChange={e => props.onChange(e)}
        className="comment-input"
        value={props.view || props.text}
        placeholder={props.placeholder}
        type={props.type}
        onKeyDown={(e) => props.onKeyDown(e) }
      />
    );
  };
  
  export default CommentInput;